import { mixin as clickAway } from 'vue-clickaway';
import { createNamespacedHelpers } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import trim from 'lodash/trim';
import pick from 'lodash/pick';
import ConciergeList from '@/components/concierge_list/ConciergeList.vue';
import LoadingDots from '@/components/loading_dot/LoadingDot.vue';
import LayoutDefs from '@/store/layout/layout.d';
import TripDefs from '@/store/trip/trip.d';
import dayjs from 'dayjs';

const { mapActions: mapLayoutActions } = createNamespacedHelpers('Layout');
const {
  mapActions: mapTripActions,
  mapState: mapTripState
} = createNamespacedHelpers('Trip');

export default {
  name: 'ReservationModal',
  mixins: [clickAway],
  components: { ConciergeList, LoadingDots },

  props: {
    formAction: {
      type: String,
      default: 'add' // or edit
    },
    bookingId: String
  },

  mounted: function() {
    if (this.formAction === 'edit') {
      this.loadReservation();
    }
  },

  data: function() {
    return {
      countOptions: Array.from(Array(30).keys(key => Number.parseInt(key))),
      restaurant: {
        restaurantName: '',
        reservationName: '',
        date: '',
        time: '',
        adultCount: 0,
        childCount: 0,
        restaurantLink: '',
        comment: ''
      }
    };
  },

  computed: {
    ...mapTripState({
      trips: state => state.trips
    }),

    /**
     * As flag indicator to disallow the user submit the form
     * Before the form is in correct shape
     */
    isAddEnabled: function() {
      const { restaurant } = this;
      const { adultCount, childCount, ...formData } = restaurant;

      if (adultCount == 0 && childCount == 0) return false;

      const hasEmptyInput = Object.keys(formData).find(key => {
        const trimmedValue = trim(formData[key]);
        return isEmpty(trimmedValue);
      });

      if (hasEmptyInput) return false;
      return true;
    }
  },

  methods: {
    ...mapLayoutActions({
      layoutStore_closeModal: LayoutDefs.actions.closeModal
    }),

    ...mapTripActions({
      tripStore_createRestaurantBooking:
        TripDefs.actions.createRestaurantBooking,
      tripStore_getRestaurantBooking: TripDefs.actions.getRestaurantBooking,
      tripStore_updateRestaurantBooking:
        TripDefs.actions.updateRestaurantBooking
    }),

    closeReservationModal: function() {
      const module = `${this.formAction}ReservationForm`;
      this.layoutStore_closeModal({ module });
    },

    /**
     * Used to retrieve the reservation detail from the store
     * and apply it to localstate. This only when form action is edit
     */
    loadReservation: function() {
      const selectedTrip = this.trips.find(({ _id }) => _id === this.bookingId);
      if (!selectedTrip) this.closeReservationModal();

      // Extract only what we need
      const choosenFields = [
        'restaurantName',
        'reservationName',
        'reservationDateTime',
        'adultCount',
        'childCount',
        'restaurantLink',
        'comment'
      ];

      // only pick certain fields
      const restaurant = pick(selectedTrip, choosenFields);
      const utcTime = selectedTrip.reservationDateTime;
      const japanTime = dayjs(utcTime)
        .utc()
        .add(9, 'hours');

      this.restaurant = {
        ...restaurant,
        date: japanTime.format('YYYY-MM-DD'),
        time: japanTime.format('HH:mm')
      };
    },

    /**
     * Handler when the add button is clicked
     * create new restaurant booking
     */
    handleOnButtonClick: async function() {
      const { date, time, ...remainingPayload } = this.restaurant;

      const payload = {
        ...remainingPayload,
        bookingId: this.bookingId,
        reservationDateTime: dayjs(`${date}T${time}+09:00`)
          .utc()
          .format('YYYY-MM-DD HH:mm')
      };

      const proceedForm =
        this.formAction === 'add'
          ? this.tripStore_createRestaurantBooking
          : this.tripStore_updateRestaurantBooking;

      await proceedForm(payload);
      this.closeReservationModal();

      // refetch the latest restaurant booking
      await this.tripStore_getRestaurantBooking();
    }
  }
};
